export default "__VITE_ASSET__DNV4jmqf__"